import classNames from 'classnames';
import React, { useId } from 'react';

import { useThemeClassName } from '../../contexts/ThemeContext';

import styles from '../../../styles/fields/checkbox.module.scss';

interface CheckboxFieldProps {
    className?: string;
    initialValue?: string;
    value?: string;
    label?: string;
    required?: boolean;
    onChange?: (value: string | null) => void;
    children?: React.ReactNode;
    [key: string]: any;
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({
    className,
    initialValue = 'yes',
    value,
    label,
    required,
    onChange = null,
    children,
    ...props
}) => {
    const themeClassName = useThemeClassName(styles);
    const id = useId();
    return (
        <label
            className={classNames([
                styles.container,
                themeClassName,
                className,
                { [styles.required]: required },
            ])}
            id={id}
        >
            <input
                id={id}
                type="checkbox"
                value={initialValue}
                checked={value === initialValue}
                onChange={(e) => {
                    if (onChange !== null) {
                        onChange(e.target.checked ? e.target.value : null);
                    }
                }}
                required={required}
                {...props}
            />
            <div className={styles.checkbox}>
                <div className={styles.checkmark} />
            </div>
            <div className={styles.content}>
                {label}
                {children}
            </div>
        </label>
    );
};

export default CheckboxField;
